import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { Clinic } from '@magnetar/admin-api-interfaces'

interface InvestorClinicsResponse {
  success: boolean
  data: Clinic[]
  error?: {
    code: string
    message: string
  }
}

export function useInvestorClinics() {
  const { token } = useAuth()

  const { data, error, isLoading, mutate } = useGet<InvestorClinicsResponse>(
    token ? '/api/investor/clinics' : null,
    undefined,
    token ?? '',
  )

  return {
    clinics: data?.data || [],
    isLoading,
    isError: error,
    mutate,
  }
}
